import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  root: {

  },
  imageContainer: {
    maxHeight: '220px',
    maxWidth: '392px',
    position: 'relative'
  },
  buttonContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  infoContainer: {
    marginLeft: spacing(2)
  },
  helperText: {
    maxWidth: '500px'
  },
  copyrightContainer: {
    marginTop: spacing(2)
  }
}))
